import {FETCH_RESULT, LIST_RESULT, DRAW_RESULT} from "../reducers/result/types";
import axios from "axios";
import {Env} from "../../config";

const basic = Env.REACT_APP_API_BASE_URL;
export const fetchResults = (params = {}) => dispatch => {
    dispatch({type: FETCH_RESULT});
    return axios.get(basic + "api/v1.0.0/mts/result", {params: params}).then(response => {
        dispatch({
            type: LIST_RESULT,
            payload: response.data
        });
        return response;
    });
};

export const setDrawingResult = (data) => dispatch => dispatch({
    type: DRAW_RESULT,
    payload: data
})



